import { NewGoalWithID } from 'shared/types/goal';
import * as yup from 'yup';

const schema = yup
  .object<NewGoalWithID>({
    id: yup.string().required(),
    name: yup.string().required(),
    lifeAreaId: yup.string().nullable(),
    color: yup.string().nullable(),
    startDate: yup.date().nullable(),
    deadline: yup.date().nullable(),
    image: yup
      .object({
        id: yup.string().required(),
        url: yup.string().required(),
        metadata: yup
          .object({
            source: yup.string().notRequired(),
            sourceName: yup.string().nullable().notRequired(),
            sourceURL: yup.string().nullable().notRequired(),
            authorName: yup.string().nullable().notRequired(),
            authorURL: yup.string().nullable().notRequired(),
          })
          .nullable()
          .notRequired(),
      })
      .nullable()
      .notRequired()
      .default(undefined),
  })
  .strip();

const arraySchema = yup.array().of(schema);

export const newGoalValidation = (goal: NewGoalWithID) =>
  schema.validateSync(goal, { stripUnknown: true }) as
    | NewGoalWithID
    | undefined;

export const newGoalsValidation = (goals: NewGoalWithID[]) =>
  arraySchema.validateSync(goals, { stripUnknown: true }) as
    | NewGoalWithID[]
    | undefined;
